import { ESymbolRoles } from '@Core/Reels/SymbolRoles';
import { IWinMultiplierPresentationConfig } from '@Core/Win/WinMultiplierPresentation';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';
import { EJackpotType } from '@Managers/Redux/HttpState';
import { IDynamicCasinoJackpotConfig } from './JackpotCasino';
import { IMultiSymbolConfig } from './MultiSymbolConfig';

export interface IFeatures {
    wild?: TSymbolIds;
    expandingWild?: Map<ESymbolRoles, TSymbolIds>;
    scatter?: TSymbolIds;
    wildWheel?: boolean;
    aboveReels?: boolean;
    tension?: boolean;
    gamble?: boolean;
    underWin?: boolean;
    infoDisplay?: boolean;
    specialGames?: ISpecialGamesFeature;
    backgroundMusic?: boolean;
    maxWin?: IMaxWinFeature;
    staticJackpot?: IStaticJackpotFeature;
    interchangeableSymbol?: TSymbolIds;
    expandingSymbol?: Map<ESymbolRoles, TSymbolIds>;
    ofAKind?: number[];
    winlines?: boolean;
    bullshitCollector?: boolean;
    collector?: boolean;
    dynamicCasinoJackpot?: IDynamicCasinoJackpotConfig;
    bonusBuy?: boolean;
    winMultiplierPresentation?: IWinMultiplierPresentationConfig;
    multiSymbol?: IMultiSymbolFeature;
}

export interface ISpecialGamesFeature {
    [ESpecialGamesType.LOCK_AND_ROLL]?: Map<ESymbolRoles, TSymbolIds>;
    [ESpecialGamesType.BONUS_PICK]?: TSymbolIds;
    [ESpecialGamesType.FREE_GAMES]?: IFreeGameFeature;
    [ESpecialGamesType.RESPINS]?: TSymbolIds;
    [ESpecialGamesType.WILD_WALL]?: TSymbolIds;
}

export interface IFreeGameFeature {
    [ESymbolRoles.SCATTER]: number[];
    [ESymbolRoles.SPECIAL_SYMBOL]?: TSpecialSymbolIdsByGameType;
}

export interface IMaxWinFeature {
    symbols: IMaxWinSymbol[];
    maxWin: number;
}

export interface IMaxWinSymbol {
    id: number;
    full: number[];
}

export interface IStaticJackpotFeature {
    symbolsById: Map<number, IJackpotSymbol>;
}

export interface IDynamicCasinoJackpotFeature {
    available: boolean;
}

export interface IJackpotSymbol {
    id: number;
    jackpotId: number;
    jackpotName: EJackpotType;
}

export interface IMultiSymbolFeature {
    config: IMultiSymbolConfig;
    componentSymbolIdsByMultiSymbolIds: Map<number, number[]>;
}

export const wildRoles = new Set([
    ESymbolRoles.WILD,
    ESymbolRoles.EXPANDING_WILD_VERTICAL,
    ESymbolRoles.EXPANDING_WILD_HORIZONTAL,
    ESymbolRoles.EXPANDING_WILD_360
]);

export type TSpecialSymbolIdsByGameType = Map<number, number>;
export type TSymbolIds = number[];
